export var Periods = ['M1', 'M5', 'M15', 'M30', 'H1', 'Day'];